import { firebaseApp } from './firebase'
import { apiPost } from './api'
import { esEscritorio } from './desktop'

// firebase/messaging se importa DINÁMICO: no debe entrar al chunk de arranque
// (el login no lo necesita y pesa ~30 kB — Lighthouse).

// Push del navegador (D-07). Opt-in explícito: enablePush() se llama desde el banner,
// nunca automático. Sin VAPID key o sin soporte (Safari viejo/iOS sin PWA) la app
// funciona igual solo con campanita — degradación silenciosa (patrón Guard).

const VAPID = import.meta.env.VITE_FCM_VAPID_KEY as string | undefined

export async function pushSupported(): Promise<boolean> {
  // ELECTRON NO TIENE WEB PUSH: no hay servicio de push detrás, así que
  // getToken() de FCM falla y el service worker de mensajería se registraría
  // para nada. En escritorio las notificaciones del sistema las manda el proceso
  // main con la clase Notification de Electron (ver lib/notifsEscritorio.ts).
  // Devolver false aquí apaga de un tiro el banner de opt-in y el registro del SW.
  if (esEscritorio()) return false
  if (!VAPID || import.meta.env.VITE_USE_EMULATORS === '1') return false
  try {
    const { isSupported } = await import('firebase/messaging')
    return (await isSupported()) && 'serviceWorker' in navigator && 'Notification' in window
  } catch {
    return false
  }
}

function swUrl(): string {
  const cfg = new URLSearchParams({
    apiKey: import.meta.env.VITE_FB_API_KEY ?? '',
    authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN ?? '',
    projectId: import.meta.env.VITE_FB_PROJECT_ID ?? '',
    appId: import.meta.env.VITE_FB_APP_ID ?? '',
    messagingSenderId: import.meta.env.VITE_FB_MESSAGING_SENDER_ID ?? '',
  })
  return `/firebase-messaging-sw.js?${cfg.toString()}`
}

export async function enablePush(): Promise<boolean> {
  if (!(await pushSupported())) return false
  const permission = await Notification.requestPermission()
  if (permission !== 'granted') return false

  const { getMessaging, getToken, onMessage } = await import('firebase/messaging')
  // SCOPE DEDICADO, no el de raíz. Las registraciones de service worker se indexan
  // por SCOPE: si este se quedara en '/' (el que hereda del path del script), el SW
  // de la PWA —que se registra en '/' en CADA arranque— reemplazaría su scriptURL y
  // desalojaría a FCM. El push moriría EN SILENCIO: el token sigue en Firestore, así
  // que la API creería que entrega. Para recibir push no hace falta controlar páginas,
  // basta con estar registrado y pasar la registración a getToken().
  const registration = await navigator.serviceWorker.register(swUrl(), {
    scope: '/firebase-cloud-messaging-push-scope',
  })
  const messaging = getMessaging(firebaseApp)
  const token = await getToken(messaging, {
    vapidKey: VAPID,
    serviceWorkerRegistration: registration,
  })
  if (!token) return false
  await apiPost('/api/me/fcm-token', { token })

  // Push en primer plano: sin notificación del sistema (la campanita ya avisa en vivo).
  onMessage(messaging, () => {})
  return true
}
